import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'
import { Link } from '../../gatsby-helpers'

const TextLink = ({ classNames, children, inherit, blogtitle, ...rest }) => (
  <Link className={cn('TextLink', { inherit, blogtitle}, classNames)} {...rest}>
    {children}
  </Link>
)

TextLink.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  inherit: PropTypes.bool
}

export default TextLink
